// extracted by mini-css-extract-plugin
export default {"slideInFromLeft":"aVrF7OrfKhPJFavsXcpO","slideInFromRight":"AxhSU5nSOhr49yT3SYlq","panelText":"dqQXErY77SnE_DPtMaOA"};